import React, { Component } from "react";
import axios from "axios";
import constant from "../../constant";
import "./style.scss";

class Terms extends Component {
  constructor(props) {
    super(props);
    this.state = { terms: [] };
  }

  componentDidMount() {
    axios.get(`${constant.phpHost}action/cms.php/?todo=terms`).then(res => {
      this.setState({
        terms: res.data
      });
    });
  }

  render() {
    let { terms } = this.state;
    return (
      <div className="terms">
        <h1>Terms</h1>
        <div
          dangerouslySetInnerHTML={{
            __html: terms && terms.content ? terms.content : ""
          }}
        />
      </div>
    );
  }
}
export default Terms;
